<template>
    <div>

        <v-toolbar dense app color="primary" flat dark>
            <v-toolbar-side-icon @click.stop="drawer()"/>
            <v-toolbar-title>Minhas Ordens</v-toolbar-title>
            <v-spacer/>
            <v-btn icon @click.stop="search = !search" v-if="ordens && ordens.length">
                <v-icon>search</v-icon>
            </v-btn>
            <v-btn icon @click.stop="sync">
                <v-icon>autorenew</v-icon>
            </v-btn>
        </v-toolbar>

        <v-container fluid v-if="search">
            <v-flex xs12  transition="fade-transition">
                <v-text-field
                    label="Busca de Cliente"
                    v-model="search_text"
                    counter
                    max="15"
                />
            </v-flex>
        </v-container>

        <v-list two-line subheader v-if="ordens && ordens.length" style="margin-top: 10px">
            <template v-for="item in getOrdens" >
                <div :key="item.id_ordem_servico">
                    <v-list-tile  avatar @click="goTo(item.id_ordem_servico)">

                        <v-list-tile-avatar>
                            <v-icon :class="[iconClass]" v-if="item.data_agendamento">access_time</v-icon>
                            <v-icon :class="[iconClass]" v-else>filter_tilt_shift</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>

                            <v-list-tile-sub-title>
                                <b>{{ item.nome_cliente }}</b>
                            </v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{ item.bairro }}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>
                                <strong v-if="Number(item.cod_cliente)">[ {{ item.cod_cliente }} ]</strong>
                                <small style="color: red" v-if="item.data_agendamento">{{item.data_agendamento | date('DD/MM/YYYY HH:mm:ss')}}</small>
                            </v-list-tile-sub-title>

                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn icon ripple>
                                <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-list-tile-action>

                    </v-list-tile>
                    <v-divider></v-divider>
                </div>
            </template>

        </v-list>

        <v-container fluid  v-if="!ordens || ! ordens.length">
            <v-alert outline color="success" icon="thumb_up" :value="true">
                Nenhuma Ordem Adicionada
            </v-alert>
        </v-container>

    </div>
</template>

<script>
    import { EventBus } from "../utils/event-bus.js";
    import { Sync } from "../class/sync";
    import { Ordens } from "../class/ordens";
    import { date } from "../filters";

    export default {
        name: "list-ordens",
        data () {
            return {
                search_text: null,
                iconClass: "blue white--text",
                search: false
            };
        },
        filters: {
            date
        },
        computed: {
            ordens () {
                return this.$store.state.ordens;
            },
            getOrdens: function () {
                if (!this.search_text) {
                    return this.ordens;
                }

                return this.ordens.filter((player) => {
                    return player.cliente.nome.toLowerCase().includes(this.search_text.toLowerCase()) ||
                        player.cod_cliente === this.search_text;
                });
            }
        },
        async beforeMount () {
            EventBus.$on("reload", async () => this.loadOrdens());
            this.sync();
        },
        beforeDestroy () {
            EventBus.$off("reload", async () => this.loadOrdens());
        },
        methods: {
            loadOrdens () {
                Ordens
                    .getAll()
                    .then((ordens) => this.$store.commit("setOrdem", ordens))
                    .catch((err) => console.error(err));
            },
            drawer: () => {
                EventBus.$emit("drawer", true);
            },
            goTo: function (id) {
                this.$router.push("/ver-ordem/" + id);
            },
            sync () {
                try {
                    Sync.syncAll(this.$socket);
                    this.loadOrdens();
                } catch (e) {
                    console.error(e);
                }
            }
        }
    };
</script>

<style scoped>

</style>
